export default class MapLocationDefinition {
    constructor(id, instanceName) {
        this._id = id;
        this._instanceName = instanceName;
    }

    get id() {
        return this._id;
    }

    get instanceName() {
        return this._instanceName;
    }
}